@if (useChecklistActions) {
  <input #tableFileInput type="file" class="d-none" accept="image/*,.pdf"
    (change)="onChecklistFileSelected($event)" />
}

@if (appSettings.isMobile()) {
  @if (!documents()?.categories?.length) {
    <app-list-card [isLoading]="true"></app-list-card>
    <app-list-card [isLoading]="true"></app-list-card>
    <app-list-card [isLoading]="true"></app-list-card>
  } @else {
    <div class="small text-muted px-1 mb-2">
      <span class="text-danger fw-semibold">*</span> son obligatorios
    </div>
    @for (category of documents()?.categories; track category.docCategoryCode; let i = $index) {
      @if (!flat()) {
        <div class="d-flex align-items-center justify-content-between my-2 px-1">
          <span class="fw-bold text-dark text-uppercase small">
            <i class="fas fa-folder-open text-primary me-2"></i>{{ category.docCategoryName }}
          </span>
          <span class="badge bg-light text-primary border rounded-pill">
            {{ category.documents?.length === 1 ? '1 requisito' : (category.documents?.length || 0) + ' requisitos' }}
          </span>
        </div>
      }

      @for (document of category?.documents; track document.docTypeCode ?? document.uuid; let j = $index) {
        <app-list-card
          [isShortcut]="hasDocumentFile(document)"
          (click)="onDocumentCardClick(document)">
          <div cardTitle class="fw-bold text-dark text-truncate">
            {{ document.docTypeName }}
            @if (document.isRequired) {
              <span class="text-danger">*</span>
            }
          </div>

          @if (mode() !== formMode.VIEW && document.isRequired === false) {
            <div cardActions>
              <button type="button" class="btn btn-outline-danger btn-xs"
                [disabled]="isDocumentBusy(document)"
                title="Quitar requisito"
                (click)="confirmDeleteDocument(document, $event)">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          }

          @if (hasDocumentFile(document)) {
            <div cardBadge class="doc-card-thumb" aria-hidden="true">
              @if (documentThumbSrc(document); as thumb) {
                <img [src]="thumb" alt="" class="doc-card-thumb-img">
              } @else if (showPdfThumb(document)) {
                <i class="fas fa-file-pdf text-danger"></i>
              } @else {
                <i class="fas fa-file text-muted"></i>
              }
            </div>
          }

          <div class="mb-1">
            @if (document.filePath) {
              <span class="text-success small" style="font-size: 0.75rem;">
                <i class="fas fa-check-circle me-1"></i>Con archivo
              </span>
            } @else {
              <span class="text-muted small" style="font-size: 0.75rem;">
                <i class="fas fa-clock me-1"></i>Sin archivo
              </span>
            }
          </div>

          <span cardExtra class="text-uppercase fw-semibold text-muted" style="font-size: 0.75rem; letter-spacing: 0.5px;">
            ESTADO
          </span>
          <div cardAmount>
            <span class="badge border" [class]="document.statusStyle">{{ document.statusName }}</span>
          </div>

          @if (!useChecklistActions && documentsArray && document.formIndex != null) {
            <app-document-form
              [documentForm]="documentsArray.at(document.formIndex)"
              [document]="document"
              [mode]="mode()"
              [compact]="true"
              [partyOverviewService]="partyOverviewService()"
              [immediateUpload]="immediateUpload()"
              (onUpdate)="onDocumentUpdate.emit()"
              (onImageClick)="openViewer($event)"
              (onUploadFile)="onUploadFile.emit($event)"
              (onDelete)="onDeleteDocument.emit($event)">
            </app-document-form>
          }

          @if (canUploadOrReplace(document)) {
            <div cardActionsRow class="d-flex gap-1">
              @if (hasDocumentFile(document)) {
                <button type="button" class="btn btn-outline-warning btn-sm w-100"
                  [disabled]="isDocumentBusy(document)"
                  (click)="$event.stopPropagation(); pickDocumentFile(document)">
                  @if (isDocumentBusy(document)) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                  } @else {
                    <i class="fas fa-upload me-1"></i>
                  }
                  Reemplazar
                </button>
              } @else {
                <button type="button" class="btn btn-success btn-sm w-100"
                  [disabled]="isDocumentBusy(document)"
                  (click)="$event.stopPropagation(); pickDocumentFile(document)">
                  @if (isDocumentBusy(document)) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                  } @else {
                    <i class="fas fa-upload me-1"></i>
                  }
                  Subir
                </button>
              }
            </div>
          }
        </app-list-card>
      }
    }
  }
} @else if (useDesktopTable && documents()) {
  <div class="table-responsive doc-checklist-scroll mt-2">
    <table class="table table-hover table-approval mb-0">
      <thead>
        <tr class="text-muted">
          <th>TIPO DE DOCUMENTO</th>
          <th class="text-center" style="width: 100px;">OBLIGATORIO</th>
          <th class="text-center" style="width: 120px;">ESTADO</th>
          <th class="text-center" style="width: 200px;"><i class="fas fa-cog"></i></th>
        </tr>
      </thead>
      <tbody>
        @for (category of documents()?.categories; track category.docCategoryCode) {
          @if (!flat()) {
            <tr>
              <td colspan="4" class="p-0 border-0">
                <div class="doc-category-header">
                  <i class="fas fa-folder-open"></i>
                  {{ category.docCategoryName | uppercase }}
                  <span class="badge border border-primary text-primary ms-3 rounded-pill">
                    {{ category.documents?.length === 1 ? 'requisito: 1' : 'requisitos: ' + (category.documents?.length || 0) }}
                  </span>
                </div>
              </td>
            </tr>
          }
          @for (document of category?.documents; track document.docTypeCode ?? document.uuid) {
            <tr>
              <td>
                <div class="fw-semibold">
                  {{ document.docTypeName }}
                  @if (document.isRequired !== false) {
                    <span class="text-danger">*</span>
                  }
                </div>
                @if (document.allowExpiration && document.expirationDate) {
                  <div class="small text-muted mt-1">
                    Vence: {{ document.expirationDate | date: 'dd/MM/yyyy' }}
                  </div>
                }
              </td>
              <td class="text-center">
                <input type="checkbox" class="form-check-input" [checked]="document.isRequired !== false" disabled>
              </td>
              <td class="text-center">
                <span class="badge border" [class]="document.statusStyle">{{ document.statusName }}</span>
              </td>
              <td class="text-center">
                <div class="d-flex align-items-center justify-content-center gap-1 flex-wrap">
                  @if (canUploadOrReplace(document)) {
                    @if (!hasDocumentFile(document)) {
                      <button type="button" class="btn btn-xs btn-success"
                        [disabled]="isDocumentBusy(document)"
                        title="Subir"
                        (click)="pickDocumentFile(document)">
                        @if (isDocumentBusy(document)) {
                          <span class="spinner-border spinner-border-sm"></span>
                        } @else {
                          <i class="fas fa-upload"></i>
                        }
                      </button>
                    } @else {
                      <button type="button" class="btn btn-xs btn-outline-primary"
                        title="Ver documento"
                        (click)="openViewer(document.uuid || document.id, $event)">
                        <i class="fas fa-eye"></i>
                      </button>
                      <button type="button" class="btn btn-xs btn-outline-warning"
                        [disabled]="isDocumentBusy(document)"
                        title="Reemplazar"
                        (click)="pickDocumentFile(document)">
                        @if (isDocumentBusy(document)) {
                          <span class="spinner-border spinner-border-sm"></span>
                        } @else {
                          <i class="fas fa-upload"></i>
                        }
                      </button>
                    }
                    @if (document.isRequired === false) {
                      <button type="button" class="btn btn-xs btn-outline-danger"
                        [disabled]="isDocumentBusy(document)"
                        title="Eliminar requisito"
                        (click)="confirmDeleteDocument(document, $event)">
                        <i class="fas fa-trash"></i>
                      </button>
                    }
                  } @else if (hasDocumentFile(document)) {
                    <button type="button" class="btn btn-xs btn-outline-primary"
                      title="Ver documento"
                      (click)="openViewer(document.uuid || document.id, $event)">
                      <i class="fas fa-eye"></i>
                    </button>
                  }
                </div>
              </td>
            </tr>
          }
        }
        @if (!documents()?.categories?.length) {
          <tr>
            <td colspan="4" class="text-center text-muted p-5">
              <i class="fas fa-folder-open fa-3x mb-3 d-block"></i>
              No hay documentos registrados para esta solicitud.
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
} @else if (documents() && documentsArray) {
  @for (category of documents()?.categories; track category.docCategoryCode; let i = $index) {
    <div [class.panel]="!embedded() && !flat()" [class.p-2]="!embedded() && !flat()" [class.mb-3]="embedded() && !flat()">
      @if (!flat()) {
        <div class="panel-header p-3 mb-0 bg-none d-flex justify-content-between align-items-center"
             [class.px-0]="embedded()" [class.pt-0]="embedded()">
          <div class="d-flex align-items-center">
            <b>{{ category.docCategoryName }}</b>
            <span class="ms-2">
              <i class="fa fa-info-circle"></i>
            </span>
          </div>
        </div>
      }
      <div [class.panel-body]="!flat()" [class.p-3]="!flat()">
        @for (document of category?.documents; track document.docTypeCode ?? document.uuid; let j = $index) {
          <app-document-form [documentForm]="documentsArray.at(document.formIndex)" [document]="document" [mode]="mode()"
            [partyOverviewService]="partyOverviewService()" [immediateUpload]="immediateUpload()"
            (onUpdate)="onDocumentUpdate.emit()" (onImageClick)="openViewer($event)"
            (onUploadFile)="onUploadFile.emit($event)" (onDelete)="onDeleteDocument.emit($event)">
          </app-document-form>
          @if (j < category?.documents?.length - 1 || (flat() && i < documents()?.categories?.length - 1)) {
            <hr class="my-4">
          }
        }
      </div>
    </div>
  }
}

<ng-content></ng-content>

@if (isViewerOpen) {
  <app-viewer
    title="Documentos del Expediente"
    [items]="viewerItems"
    [activeId]="activeViewerId"
    (onSelect)="activeViewerId = $event"
    (close)="isViewerOpen = false"
    [allowDelete]="false">
  </app-viewer>
}
